export const getBaseUrl = () => {
    return window.location.origin + window.location.pathname;
};
